import type { FC } from "react";
import KemSpeechHeader from "./components/KemSpeechHeader";
import KemSpeechIdle from "./components/KemSpeechIdle";
import KemSpeechPlaying from "./components/KemSpeechPlaying";
import KemSpeechRecording from "./components/KemSpeechRecording";
import useKemSpeechPage from "./hooks/useKemSpeechPage";
import { useViewportUnderHeader } from "./hooks/useViewportUnderHeader";

const KemSpeechPage: FC = () => {
  const { outerStyle } = useViewportUnderHeader();
  const {
    speechState,
    isLoading,
    formattedDuration,
    formattedDurationLimit,
    responseAudioUrl,
    handleStartRecording,
    handleCancelRecording,
    handleSendRecording,
    handleBackPress,
  } = useKemSpeechPage();

  return (
    <div
      className="flex w-full flex-col overflow-hidden bg-[#0D121C]"
      style={outerStyle}
    >
      <KemSpeechHeader onBack={handleBackPress} />

      <div className="flex flex-1 items-center justify-between px-6 pb-12">
        {speechState === "idle" && (
          <KemSpeechIdle
            isLoading={isLoading}
            onStartRecording={() => void handleStartRecording()}
          />
        )}

        {speechState === "recording" && (
          <KemSpeechRecording
            formattedDuration={formattedDuration}
            formattedDurationLimit={formattedDurationLimit}
            isLoading={isLoading}
            onCancel={handleCancelRecording}
            onSend={() => void handleSendRecording()}
          />
        )}

        {speechState === "playing" && (
          <KemSpeechPlaying
            audioUrl={responseAudioUrl}
            onStartRecording={() => void handleStartRecording()}
          />
        )}
      </div>
    </div>
  );
};

export default KemSpeechPage;
